import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DocumentService } from '../../../../../services/document/document.service';

@Component({
  selector: 'app-fourniss-detail-chiffre-aff',
  templateUrl: './fourniss-detail-chiffre-aff.component.html',
  styleUrls: ['./fourniss-detail-chiffre-aff.component.scss']
})
export class FournissDetailChiffreAffComponent implements OnInit, OnChanges {

  @Input() fournisseurId: number | null = null;

  totalFactures: number | null = null;
  loading = false;
  error: string | null = null;

  constructor(private documentService: DocumentService) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fournisseurId']) {
      this.loadTotalFactures();
    }
  }

  loadTotalFactures(): void {
    const id = this.fournisseurId != null ? Number(this.fournisseurId) : null;
    if (id == null || isNaN(id)) {
      this.totalFactures = null;
      return;
    }
    this.loading = true;
    this.error = null;
    this.documentService.getStatsFournisseur(id).subscribe({
      next: (res) => {
        this.loading = false;
        if (res?.success && res?.data?.total_factures?.montant_total != null) {
          this.totalFactures = Number(res.data.total_factures.montant_total);
        } else {
          this.totalFactures = 0;
        }
      },
      error: (err) => {
        this.loading = false;
        this.totalFactures = null;
        this.error = err?.error?.message || 'Erreur lors du chargement.';
      }
    });
  }

  formatMontant(montant: number | null | undefined): string {
    if (montant == null || (typeof montant === 'number' && isNaN(montant))) {
      return '--';
    }
    return `${Number(montant).toFixed(3)} TND`;
  }
}
